module.exports = __webpack_public_path__ + "img/@logo_korstock@3x.a60615c7.png";